import { useTranslation } from 'react-i18next';
import { useComponentTKey, i18nNS } from '../i18n';

// import { orderByHotelList } from '../constants/orderByLists';

const useTextOrderByHotelList = () => {
  const { t } = useTranslation(i18nNS.hotel);
  const { tKey } = useComponentTKey('orderByHotelList');
  const newOrderByHotelList = [
    {
      label: t(tKey('Best')),
      icon: 'like',
      value: 'Recommended',
    },
    {
      label: t(tKey('Dist')),
      icon: 'mark',
      value: 'distance',
    },
    {
      label: t(tKey('Price')),
      icon: 'dollar',
      value: 'price',
    },
    {
      label: t(tKey('Stars')),
      icon: 'star',
      value: 'RealRating',
    },
    {
      label: t(tKey('Reviews')),
      icon: 'message',
      value: 'ReviewRating',
    },
  ];

  return [newOrderByHotelList];
};

export default useTextOrderByHotelList;
